import * as Yup from "yup";

const VehicleMakeSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  picture: Yup.string(),
  makeId: Yup.number().required("Required"),
});

export default VehicleMakeSchema;
